import { render, staticRenderFns } from "./Diskspace.vue?vue&type=template&id=62f754d7"
import script from "./Diskspace.vue?vue&type=script&lang=js"
export * from "./Diskspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports